export default __webpack_public_path__ + "static/media/FUNKE_Medien_National_cmyk_red_black_300dpi.4c06704c.jpg";